/* sb-dc-addhang.js — record an add to cart that never comes back. 2026-09-04.

   sb-dc-addwhy.js only writes when the promise settles, so an add that simply
   never resolves leaves nothing behind: the button spins, the customer waits,
   and the log shows a lone cart_add_try. That is the blind spot behind "I press
   the button after Proof Review and nothing happens" — no error, no failure,
   no row.

   This watches the clock instead of the promise. At 25 seconds and again at 60
   it writes cart_add_hang with everything that tells us where it is stuck:

     stage      — whether the print file has reached Storage yet
     upload     — sb-dc-upload's path marker (null = export still running)
     pngfit     — encoder calls, so we know the canvas finished encoding
     printcap   — the dpi actually used, and how many pixels that is
     addon      — whether an add-on line is riding along

   When the add does finish it writes cart_add_done with the elapsed seconds,
   whatever the outcome. That gives us the distribution we have never had: how
   long a normal add takes versus one the customer would call broken.

   Nothing here changes the add. It wraps the promise, reads state and writes
   rows; every path is guarded so a logging fault cannot break an order. */
(function () {
  'use strict';

  var MARKS = [25000, 60000];

  function S() { return window.__dcSupabase || null; }
  var rawFetch = window.fetch.bind(window);

  function log(kind, meta) {
    var cfg = S();
    if (!cfg) return;
    try {
      rawFetch(cfg.url + '/rest/v1/dc_events', {
        method: 'POST',
        headers: {
          apikey: cfg.anonKey, Authorization: 'Bearer ' + cfg.anonKey,
          'Content-Type': 'application/json', Prefer: 'return=minimal'
        },
        body: JSON.stringify({
          kind: kind, ref: null, meta: meta || null,
          sid: (window.__dcSid && window.__dcSid()) || null
        }),
        keepalive: true   // so a row written as the tab closes still lands
      }).catch(function () {});
    } catch (e) {}
  }

  function snapshot() {
    var out = {};
    try {
      var p = window.__dcAppliedProduct && window.__dcAppliedProduct();
      out.handle = p && p.handle;
      var sp = window.__dcApi && window.__dcApi.spec;
      if (sp) { out.w = sp.widthIn; out.h = sp.heightIn; out.qty = sp.quantity; }
      out.upload = window.__dcUploadPath || null;
      out.stage = out.upload ? 'uploaded' : 'exporting';
      if (window.__dcPngFit) out.pngfit = window.__dcPngFit.calls + '/' + window.__dcPngFit.fixed;
      if (window.__dcPrintCap && window.__dcPrintCap.last) {
        out.dpi = window.__dcPrintCap.last.to;
        out.mp = window.__dcPrintCap.last.mpAfter;
      }
      if (window.__dcPopupStand) out.addon = !!window.__dcPopupStand.on;
    } catch (e) { out.snapshotError = String(e).slice(0, 60); }
    return out;
  }

  function install() {
    var orig = window.__dcAddToCart;
    if (typeof orig !== 'function' || orig.__dcHangWatched) return false;

    var wrapped = function () {
      var started = Date.now();
      var settled = false;
      var timers = MARKS.map(function (ms) {
        return setTimeout(function () {
          if (settled) return;
          var meta = snapshot();
          meta.waited = Math.round(ms / 1000);
          log('cart_add_hang', meta);
        }, ms);
      });

      function finish(outcome) {
        if (settled) return;
        settled = true;
        timers.forEach(clearTimeout);
        var meta = snapshot();
        meta.secs = Math.round((Date.now() - started) / 10) / 100;
        meta.outcome = outcome;
        log('cart_add_done', meta);
      }

      var out;
      try { out = orig.apply(this, arguments); }
      catch (e) { finish('threw'); throw e; }

      if (out && typeof out.then === 'function') {
        out.then(function (r) { finish(r === false ? 'false' : 'ok'); },
                 function () { finish('rejected'); });
      } else {
        finish('sync');
      }
      return out;
    };
    wrapped.__dcHangWatched = true;
    window.__dcAddToCart = wrapped;
    return true;
  }

  /* The bundle defines __dcAddToCart late and other files wrap it too, so keep
     checking and re-wrap if someone replaces it after us. */
  var t = setInterval(install, 400);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
